import { TLD_GLOBALLY } from '@/shared/constants/constants';
import { TOP_DESTINATIONS } from '@/shared/constants/topDestinations';
import { TLD } from '@/shared/types';

export function getTopDestinationsForTld(tld: TLD) {
    // This function retrieves around 15 top destinations based on tld
    // top destinations are determined by tlds
    const top_destinations = TOP_DESTINATIONS[tld] || TOP_DESTINATIONS[TLD_GLOBALLY];
    return top_destinations;
}
